module.exports = __webpack_public_path__ + "img/graphique.afd5120d.jpg";